"use client";
import { ReactNode } from "react";

export type ContextWrapperProps<T> = {
  contextValue: T;
  ContextProvider: React.ComponentType<{ value: T; children: ReactNode }>;
  children: ReactNode;
};

export function ContextWrapper<T>({ contextValue, ContextProvider, children }: ContextWrapperProps<T>) {
  return <ContextProvider value={contextValue}>{children}</ContextProvider>;
}
